import React from 'react'

import Footer from './Footer'
import Avatar from '../assets/images/avatar.jpg'
import { Link } from "gatsby"
import styled from "styled-components"
import '../assets/scss/main.scss'

class Header extends React.Component {

    render() {
        const StyledLink = styled(Link)`
        color: white;
        `;
        return (
            <header id="header">
                <div className="inner" align="right">
                    <div class="image-cropper"> <img src={Avatar}/></div>
                    <h1><strong>I'm Abby Krishnan</strong></h1>
                    <h3><i>CS '21 at UT Austin.</i></h3>
                    <StyledLink to="/">Home</StyledLink>
                    <br></br>
                    <StyledLink to="/projects/">Projects</StyledLink>
                    <br></br>
                    <StyledLink to="/musings/">Musings</StyledLink>

                </div>
                <Footer/>
            </header>
        )
    }
}

export default Header
